import React from 'react';

import Chat from 'component/User/Community/Chat';
import Group from 'component/User/Community/Group';

import classNames from 'classnames';

import { Source } from 'types/common';

import { Conversation } from 'proto/Community/Conversation';
import { Group as GroupModel } from 'proto/Community/Group';

import styles from './Community.module.scss';

export interface CommunityProps {
    groupList: GroupModel[];
    conversation: Conversation;
    source: Source;
    chatSource: Source;
}
const Community = ({
    groupList,
    conversation,
    source,
    chatSource,
}: CommunityProps) => {
    return (
        <div
            className={classNames(styles.Box, {
                [styles.Bright]: Object.entries(groupList).length < 3,
            })}
        >
            {Object.entries(groupList).map(([name, value]) => (
                <Group key={name} groupModel={value} source={source} />
            ))}
            <Chat conversation={conversation} chatSource={chatSource} />
        </div>
    );
};

export default Community;
